import React from "react";

const IconProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

// Badezimmer
export const Hairdryer = () => (
  <svg {...IconProps}>
    <path d="M10 7h7.5a3.5 3.5 0 0 1 0 7H10V7Z" />
    <path d="M10 9v12" />
    <path d="M10 15H7a4 4 0 0 1-4-4v-1a4 4 0 0 1 4-4h3" />
  </svg>
);
export const Shampoo = () => (
  <svg {...IconProps}>
    <rect x="7" y="5" width="10" height="14" rx="2" />
    <path d="M10 2h4v3h-4z" />
    <path d="M10 9h4" />
  </svg>
);
export const Soap = () => (
  <svg {...IconProps}>
    <rect x="3" y="8" width="18" height="12" rx="4" />
    <path d="M7 12h10" />
    <path d="M7 16h5" />
  </svg>
);
export const WC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    style={{
      display: "block",
      height: "24px",
      width: "24px",
      fill: "currentcolor",
    }}
  >
    <path d="M10 2a3 3 0 0 1 3 2.82V16h14a1 1 0 0 1 1 .88V17a8 8 0 0 1-7.75 8h-4.77l1.45 3.63a1 1 0 0 1-.7 1.35l-.11.01L16 30H4a1 1 0 0 1-1-.88V5a3 3 0 0 1 2.82-3H10zm15.91 16H5v10h9.52l-1.45-3.63a1 1 0 0 1 .7-1.35l.11-.01L14 23h6a6 6 0 0 0 5.85-4.67l.05-.23.01-.1zM10 4H6a1 1 0 0 0-1 .88V16h6V5a1 1 0 0 0-.77-.97L10.12 4 10 4zM8 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"></path>{" "}
  </svg>
);
export const HotWater = () => (
  <svg {...IconProps}>
    <path d="M12 2v10" />
    <path d="M16 7l-4 4-4-4" />
    <path d="M7 17a5 5 0 0 0 10 0" />
  </svg>
);

// Wäsche
export const WashingMachine = () => (
  <svg {...IconProps}>
    <rect x="5" y="3" width="14" height="18" rx="2" />
    <circle cx="12" cy="13" r="4" />
    <path d="M8 6h.01" />
    <path d="M11 6h.01" />
  </svg>
);
export const Essentials = () => (
  <svg {...IconProps}>
    <path d="M6 18h12" />
    <path d="M6 14h12" />
    <path d="M6 10h12" />
    <path d="M6 6h12" />
    <rect x="3" y="3" width="18" height="18" rx="2" />
  </svg>
);
export const Hanger = () => (
  <svg {...IconProps}>
    <path d="M12 2a2 2 0 0 1 2 2c0 .7-.3 1.3-.8 1.7L22 15a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2L10.8 5.7c-.5-.4-.8-1-.8-1.7a2 2 0 0 1 2-2Z" />
  </svg>
);

export const Iron = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    style={{
      display: "block",
      height: "24px", // Auf 24px angepasst
      width: "24px", // Auf 24px angepasst
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
    }}
    {...props}
  >
    <path d="M4 17h15a2 2 0 0 0 2-2v-2c0-4-3-7-7-7h-5l-5 5v6z" />

    <path d="M9 8V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v3" />

    <path d="M7 21v-1" />
    <path d="M12 21v-1" />
    <path d="M17 21v-1" />
  </svg>
);

// Küche
export const Fridge = () => (
  <svg {...IconProps}>
    <rect x="5" y="2" width="14" height="20" rx="2" />
    <path d="M5 10h14" />
    <path d="M9 5v2" />
    <path d="M9 14v4" />
  </svg>
);
export const Pan = () => (
  <svg {...IconProps}>
    <circle cx="11" cy="13" r="7" />
    <path d="M18 13h4" />
  </svg>
);
export const QboMachine = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    style={{
      display: "block",
      height: "24px",
      width: "24px",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
    }}
    {...props}
  >
    <path d="M4 19h16a1 1 0 0 1 1 1v1H3v-1a1 1 0 0 1 1-1Z" />

    <path d="M6 19V6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13" />

    <path d="M10 4V2h4v2" />

    <path d="M14 2l2-2" />

    <path d="M18 9h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1" />

    <path d="M19 15v2" />

    <path d="M14 4v15" />
  </svg>
);
export const WineGlass = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M8 3h8" />
    <path d="M8 3v7a4 4 0 0 0 8 0V3" />
    <path d="M12 14v7" />
    <path d="M9 21h6" />
  </svg>
);

// Sicherheit & Familie
export const Extinguisher = () => (
  <svg {...IconProps}>
    <rect x="8" y="8" width="8" height="14" rx="2" />
    <path d="M12 8V4" />
    <path d="M9 4h6" />
    <path d="M15 6a3 3 0 0 0-6 0" />
  </svg>
);
export const FirstAid = () => (
  <svg {...IconProps}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M12 9v6" />
    <path d="M9 12h6" />
  </svg>
);
export const Child = () => (
  <svg {...IconProps}>
    <path d="M12 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
    <path d="M18 21v-4a4 4 0 0 0-4-4h-4a4 4 0 0 0-4 4v4" />
  </svg>
);
export const BoardGame = () => (
  <svg {...IconProps}>
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M9 9h.01" />
    <path d="M15 15h.01" />
    <path d="M15 9h.01" />
    <path d="M9 15h.01" />
    <path d="M12 12h.01" />
  </svg>
);

// Außenbereich
export const GardenFurniture = () => (
  <svg {...IconProps}>
    <path d="M18 20V10" />
    <path d="M6 20V10" />
    <path d="M2 10h20" />
    <path d="M8 10V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v6" />
  </svg>
);

export const Aircondition = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    aria-hidden="true"
    role="presentation"
    width="24"
    height="24"
    focusable="false"
    fill="currentColor"
  >
    <path
      d="M17 1v4.03l4.03-2.32 1 1.73L17 7.34v6.93l6-3.47V5h2v4.65l3.49-2.02 1 1.74L26 11.38l4.03 2.33-1
        1.73-5.03-2.9L18 16l6 3.46 5.03-2.9 1 1.73L26 20.62l3.49 2.01-1 1.74L25 22.35V27h-2v-5.8l-6-3.47v6.93l5.03
        2.9-1 1.73L17 26.97V31h-2v-4.03l-4.03 2.32-1-1.73 5.03-2.9v-6.93L9 21.2V27H7v-4.65l-3.49 2.02-1-1.74L6
        20.62l-4.03-2.33 1-1.73L8 19.46 14 16l-6-3.46-5.03 2.9-1-1.73L6 11.38 2.51 9.37l1-1.74L7 9.65V5h2v5.8l6
        3.47V7.34l-5.03-2.9 1-1.73L15 5.03V1z"
    />
  </svg>
);

export const Balcony = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 512 512"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="currentColor"
      /* 1. Konturfarbe hinzufügen */
      strokeWidth="50"
      /* 2. Dicke anpassen (10-20 ist ein guter Bereich für "etwas stärker") */
      strokeLinejoin="round"
      /* 3. Ecken abrunden, damit es sauber aussieht */
    >
      <path d="M825 5095 l-25 -24 0 -1090 0 -1090 -381 -3 -381 -3 -19 -24 c-18 -21 -19 -42 -19 -265 0 -202 3 -245 16 -264 15 -21 21 -22 190 -22 96 0 174 -2 174 -3 0 -2 -9 -46 -19 -98 -57 -273 -75 -493 -68 -846 5 -307 18 -442 64 -663 21 -99 28 -165 32 -315 6 -189 6 -190 37 -245 33 -60 99 -112 162 -130 51 -14 3893 -14 3944 0 63 18 129 70 162 130 31 55 31 56 37 245 4 151 11 216 32 315 52 250 62 366 62 735 0 223 -5 378 -13 450 -12 99 -54 344 -69 403 l-5 22 175 0 c170 0 176 1 191 22 13 19 16 62 16 264 0 223 -1 244 -19 265 l-19 24 -381 3 -381 3 0 1090 0 1090 -25 24 -24 25 -1711 0 -1711 0 -24 -25z m3355 -1160 l0 -1045 -90 0 -90 0 0 249 c0 236 -1 250 -21 275 l-20 26 -635 0 c-621 0 -634 0 -654 -20 -19 -19 -20 -33 -20 -275 l0 -255 -90 0 -90 0 0 255 c0 242 -1 256 -20 275 -20 20 -33 20 -654 20 l-635 0 -20 -26 c-20 -25 -21 -39 -21 -275 l0 -249 -90 0 -90 0 0 1045 0 1045 1620 0 1620 0 0 -1045z m-1850 -840 l0 -205 -535 0 -535 0 0 205 0 205 535 0 535 0 0 -205z m1530 0 l0 -205 -535 0 -535 0 0 205 0 205 535 0 535 0 0 -205z m1120 -495 l0 -150 -2420 0 -2420 0 0 150 0 150 2420 0 2420 0 0 -150z m-2660 -309 c0 -11 -6 -50 -14 -88 -50 -238 -82 -629 -72 -883 10 -239 45 -533 85 -702 l9 -38 -255 0 c-238 0 -254 1 -249 18 11 37 46 243 63 367 14 102 18 203 18 475 0 369 -8 470 -61 740 -13 69 -24 126 -24 128 0 1 113 2 250 2 241 0 250 -1 250 -19z m980 17 c0 -2 -11 -59 -24 -128 -52 -268 -61 -372 -61 -730 0 -213 5 -373 13 -440 13 -108 58 -382 68 -412 5 -17 -11 -18 -249 -18 l-254 0 18 88 c96 453 101 993 14 1474 -14 76 -25 145 -25 153 0 13 34 15 250 15 138 0 250 -1 250 -2z m967 -30 c-3 -18 -15 -81 -26 -140 -44 -234 -56 -379 -56 -693 0 -321 12 -457 61 -722 13 -73 24 -135 24 -138 0 -3 -112 -5 -250 -5 -148 0 -250 4 -250 9 0 5 7 43 15 83 96 454 98 1040 5 1519 -11 57 -20 107 -20 112 0 4 113 7 251 7 l252 0 -6 -32z m-3545 -63 c103 -481 103 -1045 0 -1545 l-18 -85 -91 -3 -91 -3 -26 135 c-53 276 -60 367 -61 726 0 359 9 465 61 727 13 68 24 125 24 128 0 3 42 4 92 3 l93 -3 17 -80z m624 59 c-15 -57 -55 -315 -68 -429 -8 -74 -13 -234 -13 -415 1 -315 12 -443 60 -704 14 -74 25 -138 25 -141 0 -3 -113 -5 -251 -5 l-251 0 6 33 c64 310 81 489 81 832 0 348 -17 517 -81 823 l-6 32 252 0 252 0 -6 -26z m348 -51 c60 -289 80 -522 73 -870 -6 -279 -18 -400 -63 -636 l-26 -138 -91 3 -91 3 -18 85 c-102 496 -104 1005 -6 1510 11 58 22 108 25 113 2 4 44 7 92 7 l88 0 17 -77z m960 60 c11 -38 46 -234 61 -340 56 -415 37 -910 -51 -1294 l-16 -69 -88 0 -88 0 -16 69 c-88 384 -107 879 -51 1294 14 103 49 298 61 340 5 14 18 17 94 17 76 0 89 -3 94 -17z m993 -93 c40 -193 64 -414 70 -650 8 -309 -16 -582 -75 -870 l-18 -85 -91 -3 -91 -3 -26 135 c-52 274 -60 367 -61 726 0 224 4 366 13 430 19 139 40 264 59 353 l16 78 91 -3 91 -3 22 -105z m972 8 c58 -281 75 -491 68 -841 -6 -292 -16 -391 -63 -640 l-26 -138 -92 3 -91 3 -22 110 c-80 400 -94 873 -37 1275 16 111 53 310 61 323 2 4 44 7 92 7 l88 0 22 -102z m-29 -1855 c0 -116 -16 -159 -70 -185 -33 -17 -147 -18 -1960 -18 -1813 0 -1927 1 -1960 18 -54 26 -70 69 -70 185 l0 97 2030 0 2030 0 0 -97z" />
      <path d="M1145 4775 l-25 -24 0 -541 0 -541 25 -24 24 -25 626 0 626 0 24 25 25 24 0 544 0 544 -23 21 -23 22 -628 0 -627 0 -24 -25z m1185 -565 l0 -450 -535 0 -535 0 0 450 0 450 535 0 535 0 0 -450z" />
      <path d="M2672 4777 l-22 -23 0 -543 0 -542 25 -24 24 -25 626 0 626 0 24 25 25 24 0 541 0 541 -25 24 -24 25 -629 0 -629 0 -21 -23z m1188 -567 l0 -450 -535 0 -535 0 0 450 0 450 535 0 535 0 0 -450z" />
    </g>
  </svg>
);

// 1. Deine speziellen Icons mit 512er Viewbox
const ComplexIcon = ({
  children,
  viewBox = "0 0 512 512",
  ...props
}: {
  children: React.ReactNode;
  viewBox?: string;
}) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox={viewBox}
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="none"
    >
      {children}
    </g>
  </svg>
);

export const Cutlery = (props) => (
  <ComplexIcon {...props}>
    <path
      d="M4675 5110 c-150 -20 -333 -85 -473 -168 -321 -191 -558 -539 -639 -939 -27 -134 -25 -444 5 -575 58 -262 161 -471 329 -664 l70 -80 -18 -23 c-18 -22 -19 -66 -19 -1120 0 -1032 1 -1100 18 -1162 44 -158 161 -284 319 -346 59 -23 82 -27 178 -26 123 0 189 18 276 74 62 39 153 138 183 197 60 119 56 -61 56 2457 l0 2302 -21 27 c-43 55 -107 66 -264 46z m25 -2458 l0 -2198 -26 -52 c-44 -89 -132 -142 -234 -142 -59 0 -160 49 -195 94 -58 76 -55 18 -55 1106 l0 1000 70 0 c110 0 175 39 186 112 11 65 -14 100 -123 171 -225 146 -378 342 -461 592 -189 570 60 1196 572 1436 75 35 208 77 249 78 16 1 17 -110 17 -2197z"
      stroke="currentColor"
      strokeWidth="20"
    />
    <path
      d="M875 5049 c-292 -27 -558 -281 -659 -630 -157 -545 96 -1141 544 -1280 l55 -17 3 -200 2 -201 -160 -3 -160 -3 -32 -33 -33 -32 -3 -1093 c-2 -799 0 -1107 8 -1147 32 -149 136 -283 274 -350 96 -48 176 -64 271 -56 214 17 391 159 455 365 19 61 20 93 20 1167 l0 1104 -34 38 -34 37 -156 3 -156 3 0 202 0 202 76 24 c133 42 289 166 383 304 54 79 120 230 148 334 34 133 43 356 19 495 -40 234 -131 416 -286 568 -157 154 -332 218 -545 199z m200 -276 c146 -51 282 -211 343 -403 37 -115 45 -182 39 -327 -6 -157 -25 -240 -84 -359 -206 -417 -647 -415 -857 3 -14 28 -38 91 -53 140 -24 80 -27 103 -27 253 0 140 4 177 22 245 66 239 226 421 403 460 70 15 149 11 214 -12z m133 -3310 l-3 -998 -28 -57 c-46 -94 -132 -148 -237 -148 -60 0 -159 48 -195 95 -58 77 -55 18 -55 1105 l0 1000 260 0 261 0 -3 -997z"
      stroke="currentColor"
      strokeWidth="20"
    />
    <path
      d="M2564 4790 c-218 -32 -394 -195 -440 -409 -11 -54 -14 -255 -14 -1131 0 -994 1 -1067 18 -1099 34 -68 56 -76 223 -79 l149 -4 0 -239 0 -239 -73 0 c-218 0 -385 -142 -433 -368 -11 -53 -14 -178 -14 -586 0 -503 1 -521 20 -562 34 -69 113 -94 177 -54 59 36 58 17 63 615 l5 550 24 48 c34 71 79 97 163 97 l68 0 0 -613 c0 -574 1 -614 18 -646 20 -37 73 -71 110 -71 40 0 91 28 112 62 19 32 20 49 20 651 l0 617 68 0 c83 0 119 -20 159 -87 l28 -48 5 -557 c5 -545 5 -557 26 -585 49 -66 159 -66 206 0 l23 32 3 530 c2 363 -1 552 -9 598 -16 97 -66 192 -139 261 -84 80 -149 107 -272 114 l-98 5 0 237 0 238 148 4 c164 3 185 10 223 71 19 31 19 54 17 1137 l-3 1105 -23 60 c-48 126 -137 229 -251 288 -100 53 -203 72 -307 57z m186 -285 c27 -13 62 -41 79 -62 64 -77 61 -27 61 -1120 l0 -992 -260 0 -260 0 0 987 c0 615 4 1000 10 1022 25 90 105 168 193 191 48 12 124 1 177 -26z"
      stroke="currentColor"
      strokeWidth="20"
    />
  </ComplexIcon>
);

export const M2 = () => (
  <ComplexIcon>
    <path
      d="M533 4587 c-229 -228 -235 -237 -192 -291 15 -20 29 -26 57 -26 34 0 47 11 164 127 l128 128 0 -1685 c0 -1058 4 -1711 10 -1755 28 -197 188 -356 386 -385 44 -6 689 -10 1754 -10 l1685 0 -128 -128 c-116 -117 -127 -130 -127 -164 0 -28 6 -42 26 -57 54 -43 63 -37 291 192 181 181 213 217 213 242 0 25 -32 61 -213 242 -174 175 -217 213 -240 213 -39 0 -77 -41 -77 -82 0 -29 15 -49 125 -158 69 -69 125 -128 125 -133 0 -4 -773 -6 -1717 -5 l-1718 3 -51 23 c-64 29 -126 92 -156 157 l-23 50 -3 1718 c-1 944 1 1717 5 1717 5 0 64 -56 133 -125 109 -110 129 -125 158 -125 41 0 82 38 82 77 0 23 -38 66 -213 240 -181 181 -217 213 -242 213 -25 0 -61 -32 -242 -213z"
      stroke="currentColor"
      strokeWidth="150"
    />
    <path
      d="M1576 4779 c-34 -27 -37 -86 -5 -115 20 -18 62 -19 1438 -24 l1416 -5 45 -24 c61 -32 107 -76 138 -136 l27 -50 5 -1416 c5 -1376 6 -1418 24 -1438 29 -32 88 -29 115 5 l21 27 0 1396 c0 1521 3 1447 -56 1563 -33 66 -116 149 -182 182 -116 59 -42 56 -1563 56 l-1396 0 -27 -21z"
      stroke="currentColor"
      strokeWidth="150"
    />
    <path
      d="M3642 3929 c-108 -42 -192 -164 -192 -278 0 -58 29 -91 78 -91 41 0 69 28 77 77 14 91 63 143 143 151 139 13 220 -149 125 -252 -16 -17 -92 -98 -169 -181 -213 -229 -214 -230 -214 -270 0 -19 5 -46 12 -60 23 -50 47 -55 291 -55 249 0 261 3 273 66 5 24 0 37 -19 60 l-25 29 -151 5 -151 5 150 160 c83 88 159 178 170 201 82 168 5 370 -167 434 -70 26 -161 26 -231 -1z"
      stroke="currentColor"
      strokeWidth="100"
    />
    <path
      d="M1693 3476 l-28 -24 -3 -789 c-1 -433 0 -798 3 -811 15 -60 92 -83 133 -39 21 22 21 25 24 647 3 552 5 629 19 661 90 197 358 215 466 31 l28 -47 5 -638 5 -639 24 -19 c35 -28 85 -25 110 7 21 26 21 35 21 629 0 697 -2 677 84 761 36 35 66 54 99 63 57 16 151 10 195 -13 44 -23 95 -75 118 -122 18 -37 19 -72 24 -672 l5 -634 24 -19 c33 -27 77 -24 107 6 l25 25 -3 643 -3 643 -38 76 c-46 94 -129 176 -214 209 -47 19 -77 23 -163 24 -97 0 -110 -2 -172 -32 -36 -17 -89 -53 -116 -80 l-50 -48 -60 56 c-86 82 -148 104 -282 104 -101 0 -109 -2 -175 -35 -39 -19 -73 -36 -77 -38 -5 -2 -8 19 -8 46 0 43 -4 54 -26 71 -35 28 -67 26 -101 -3z"
      stroke="currentColor"
      strokeWidth="100"
    />
  </ComplexIcon>
);

export const Nature = () => (
  <ComplexIcon>
    <path
      d="M2472 5083 c-290 -172 -559 -472 -708 -789 -106 -227 -174 -520 -174 -754 0 -63 -2 -71 -17 -66 -10 3 -68 10 -130 16 -198 20 -425 -15 -619 -94 -296 -121 -559 -370 -694 -659 -52 -110 -57 -137 -34 -175 29 -50 97 -68 140 -37 12 8 46 65 77 127 177 362 513 597 912 638 107 11 264 2 345 -20 l36 -10 18 -96 c82 -442 339 -849 709 -1127 59 -44 107 -85 107 -91 0 -32 -48 -174 -86 -255 -165 -352 -492 -594 -871 -646 l-53 -7 0 194 0 193 239 239 c157 157 241 248 244 265 13 65 -56 132 -119 117 -19 -5 -89 -67 -196 -174 l-168 -166 0 388 0 388 -35 35 c-32 32 -40 35 -73 30 -24 -4 -47 -17 -64 -37 l-28 -30 0 -172 0 -173 -110 110 c-108 108 -111 110 -156 110 -60 0 -94 -36 -94 -97 0 -41 5 -47 180 -223 l180 -181 0 -407 0 -408 -48 7 c-178 25 -388 111 -526 216 -152 115 -276 268 -356 441 -44 95 -67 117 -123 117 -43 0 -82 -31 -93 -74 -8 -35 25 -122 89 -234 203 -356 550 -596 955 -660 l102 -16 0 -318 0 -318 -575 0 c-479 0 -581 -2 -604 -14 -66 -35 -66 -137 0 -172 42 -21 4976 -21 5018 0 66 35 66 137 0 172 -23 12 -129 14 -634 14 l-605 0 0 316 c0 297 1 316 18 309 66 -28 175 -56 254 -66 393 -48 789 183 943 549 56 134 70 210 69 367 -1 165 -20 246 -87 389 -72 151 -185 280 -322 368 l-59 39 2 112 c4 126 -12 224 -53 332 -95 253 -321 456 -590 530 -96 26 -283 30 -387 7 l-88 -18 0 88 c0 495 -217 991 -581 1332 -142 132 -338 266 -389 266 -14 0 -53 -17 -88 -37z m154 -224 c150 -105 270 -223 386 -379 213 -287 331 -671 316 -1028 l-6 -116 -33 -25 -25 -24 c-68 -49 -198 -190 -238 -258 -90 -151 -127 -303 -119 -492 l5 -120 -96 -94 c-53 -51 -115 -108 -138 -126 l-43 -33 0 584 0 583 156 155 c85 85 162 168 170 183 32 60 -21 137 -93 137 -32 0 -47 -11 -134 -97 l-99 -97 0 223 c0 241 -5 266 -55 289 -51 23 -107 7 -131 -39 -11 -23 -14 -109 -14 -486 l0 -457 -138 137 c-128 127 -141 137 -176 137 -48 0 -72 -13 -92 -52 -31 -60 -20 -77 201 -298 l205 -205 0 -348 0 -349 -42 34 c-304 238 -523 599 -598 985 -122 628 145 1282 674 1652 33 22 62 41 66 41 4 0 33 -19 66 -41z m1372 -1622 c106 -37 176 -82 262 -167 158 -158 219 -363 178 -601 -16 -93 -7 -109 100 -170 148 -85 236 -176 306 -315 55 -111 70 -181 70 -324 0 -143 -21 -225 -89 -347 -46 -82 -175 -213 -257 -261 -130 -76 -308 -114 -447 -94 -88 13 -190 44 -247 76 l-39 22 -3 299 -2 300 204 205 c132 132 207 215 212 233 14 60 -37 117 -107 117 -28 0 -51 -18 -171 -137 l-138 -137 0 107 c0 132 -13 171 -65 193 -29 12 -44 13 -71 4 -64 -21 -64 -21 -64 -367 0 -172 -3 -313 -7 -313 -4 0 -62 54 -128 120 -120 118 -122 120 -168 120 -38 0 -49 -5 -71 -31 -17 -20 -26 -42 -26 -66 0 -34 14 -51 200 -238 l201 -202 -3 -103 -3 -103 -59 -33 c-126 -69 -329 -90 -463 -47 -211 69 -369 235 -423 449 -52 202 5 415 151 569 78 82 146 125 255 163 122 43 139 82 90 204 -133 333 22 708 352 855 92 40 165 53 287 49 86 -3 126 -9 183 -29z m-1538 -2412 l0 -625 -515 0 -515 0 0 318 0 318 105 16 c337 54 652 242 855 512 36 47 66 86 67 86 2 0 3 -281 3 -625z m400 44 c152 -90 344 -131 512 -110 51 7 125 23 166 37 40 13 77 24 82 24 6 0 10 -114 10 -310 l0 -310 -485 0 -485 0 0 416 0 416 65 -60 c35 -34 96 -80 135 -103z"
      stroke="currentColor"
      strokeWidth="100"
    />
    <path d="M4395 5105 c-219 -48 -393 -219 -450 -440 -20 -77 -19 -211 1 -289 53 -205 224 -375 434 -431 72 -19 210 -19 285 0 253 65 434 281 452 539 12 172 -49 330 -175 456 -149 149 -348 209 -547 165z m265 -209 c60 -21 136 -80 182 -141 121 -160 95 -389 -60 -532 -15 -13 -56 -39 -92 -56 -61 -30 -72 -32 -170 -32 -96 0 -110 3 -165 30 -77 38 -153 114 -191 190 -26 55 -29 69 -29 165 0 94 3 111 27 163 72 154 216 242 378 233 41 -3 95 -12 120 -20z" />
    <path d="M63 2255 c-99 -43 -71 -185 36 -185 96 0 138 124 59 173 -37 24 -61 27 -95 12z" />
  </ComplexIcon>
);

export const Parking = () => (
  <ComplexIcon>
    <path
      d="M404 4951 c-47 -12 -133 -62 -160 -94 -14 -17 -37 -53 -52 -81 l-27 -51 0 -1125 0 -1125 34 -63 c38 -70 69 -100 145 -140 l51 -27 483 -3 482 -3 0 80 0 80 -468 3 -469 3 -37 29 c-70 53 -67 -20 -64 1180 3 1078 3 1085 24 1112 11 15 33 37 48 48 27 21 34 21 1112 24 1200 3 1127 6 1180 -64 l29 -37 3 -709 2 -708 81 0 80 0 -3 723 -3 722 -34 63 c-38 70 -69 100 -145 140 l-51 27 -1105 2 c-608 0 -1119 -2 -1136 -6z"
      stroke="currentColor"
      strokeWidth="100"
    />
    <path
      d="M665 4616 l-25 -25 0 -991 0 -991 25 -24 24 -25 271 0 271 0 24 25 25 24 0 295 0 294 268 4 c254 4 271 6 344 30 119 40 204 92 294 182 90 90 143 175 182 294 22 67 26 94 26 212 0 118 -4 145 -26 212 -39 119 -92 204 -182 294 -90 90 -174 142 -294 183 l-77 26 -562 3 -563 3 -25 -25z m1121 -147 c98 -17 213 -79 288 -155 219 -218 219 -567 1 -787 -76 -77 -190 -138 -289 -156 -33 -6 -184 -11 -338 -11 l-279 0 -24 -25 -25 -24 0 -296 0 -295 -160 0 -160 0 0 880 0 880 463 0 c285 0 486 -4 523 -11z"
      stroke="currentColor"
      strokeWidth="100"
    />
    <path
      d="M1145 4135 c-25 -24 -25 -26 -25 -215 0 -189 0 -191 25 -215 l24 -25 272 0 c184 0 285 4 313 12 86 26 166 136 166 228 0 92 -80 202 -166 228 -28 8 -129 12 -313 12 l-272 0 -24 -25z m590 -160 c16 -15 25 -36 25 -55 0 -19 -9 -40 -25 -55 -24 -25 -24 -25 -240 -25 l-215 0 0 80 0 80 215 0 c216 0 216 0 240 -25z"
      stroke="currentColor"
      strokeWidth="100"
    />
    <path
      d="M2005 3106 c-22 -7 -54 -20 -71 -29 -33 -17 -104 -90 -124 -128 -7 -13 -88 -248 -180 -523 l-166 -500 -65 -16 c-35 -9 -79 -24 -98 -34 -53 -28 -120 -102 -149 -164 l-27 -57 0 -390 0 -390 27 -51 c40 -76 70 -107 140 -145 l63 -34 323 -3 322 -3 0 -160 0 -159 -240 0 -240 0 0 80 0 80 -80 0 -80 0 0 -95 c0 -113 13 -151 66 -191 l37 -29 298 0 c285 0 299 1 325 21 66 49 69 58 72 265 l3 189 880 0 879 0 0 -175 c0 -200 6 -226 66 -271 l37 -29 298 0 c285 0 299 1 325 21 67 49 69 57 72 267 l3 192 65 34 c71 37 102 68 142 145 l27 51 0 390 0 390 -27 57 c-29 62 -96 136 -149 164 -19 10 -63 25 -98 34 l-65 16 -167 502 c-92 276 -176 517 -188 535 -31 51 -92 104 -146 129 l-50 23 -1010 2 c-795 1 -1019 -1 -1050 -11z m2055 -168 c45 -23 73 -59 85 -110 l7 -28 -1112 0 -1112 0 7 28 c11 48 40 86 81 109 l39 23 980 0 981 0 44 -22z m268 -658 l120 -360 -1408 0 -1408 0 120 360 120 360 1168 0 1168 0 120 -360z m357 -539 c49 -22 91 -69 105 -119 8 -24 10 -153 8 -379 -3 -327 -4 -343 -24 -369 -11 -15 -33 -37 -48 -48 l-27 -21 -1658 0 -1658 0 -37 29 c-65 49 -66 56 -66 431 0 280 3 342 15 373 21 49 52 81 100 103 38 18 106 19 1645 19 1536 0 1607 -1 1645 -19z m-125 -1261 l0 -160 -240 0 -240 0 0 160 0 160 240 0 240 0 0 -160z"
      stroke="currentColor"
      strokeWidth="100"
    />
    <path d="M1660 1584 c-142 -52 -229 -183 -218 -327 26 -318 443 -407 597 -127 33 60 36 71 36 150 -1 72 -5 93 -27 136 -39 75 -70 107 -138 143 -76 41 -179 51 -250 25z m163 -158 c103 -43 128 -177 48 -257 -65 -65 -157 -65 -222 0 -124 123 13 325 174 257z" />
    <path d="M4220 1584 c-142 -52 -229 -183 -218 -327 26 -318 443 -407 597 -127 33 60 36 71 36 150 -1 72 -5 93 -27 136 -39 75 -70 107 -138 143 -76 41 -179 51 -250 25z m163 -158 c103 -43 128 -177 48 -257 -65 -65 -157 -65 -222 0 -124 123 13 325 174 257z" />
    <path d="M2240 1440 l0 -80 800 0 800 0 0 80 0 80 -800 0 -800 0 0 -80z" />
    <path d="M2240 1120 l0 -80 800 0 800 0 0 80 0 80 -800 0 -800 0 0 -80z" />
  </ComplexIcon>
);

export const Sea = () => (
  <ComplexIcon>
    <path
      d="M1834 5111 c-47 -20 -54 -46 -54 -201 0 -122 3 -149 18 -167 36 -48 127 -46 159 4 13 19 19 53 21 124 5 124 -3 182 -31 215 -24 27 -79 39 -113 25z"
      stroke="currentColor"
      strokeWidth="100"
    />
    <path
      d="M806 4679 c-72 -56 -56 -106 73 -232 87 -86 102 -97 134 -97 43 0 92 38 100 77 9 46 -15 83 -115 181 -83 80 -100 92 -130 92 -21 0 -46 -9 -62 -21z"
      stroke="currentColor"
      strokeWidth="100"
    />
    <path
      d="M2752 4608 c-100 -98 -124 -135 -115 -181 8 -39 57 -77 100 -77 32 0 47 11 134 97 104 101 127 141 110 185 -14 38 -58 68 -99 68 -30 0 -47 -12 -130 -92z"
      stroke="currentColor"
      strokeWidth="100"
    />
    <path
      d="M1730 4538 c-97 -13 -250 -69 -342 -124 -95 -57 -232 -182 -293 -268 -59 -84 -110 -189 -142 -293 -25 -81 -27 -101 -27 -263 0 -162 2 -182 27 -263 104 -336 352 -576 693 -668 112 -31 345 -31 456 -1 345 94 591 331 695 669 25 81 27 101 27 263 0 162 -2 182 -27 263 -96 312 -322 546 -622 646 -145 48 -292 61 -445 39z m335 -214 c248 -67 445 -252 532 -499 26 -74 28 -91 28 -235 0 -144 -2 -161 -28 -235 -42 -121 -99 -209 -196 -305 -70 -70 -104 -94 -181 -133 -131 -65 -199 -81 -345 -81 -146 0 -214 16 -345 81 -170 85 -310 248 -377 438 -26 74 -28 91 -28 235 0 144 2 161 28 235 97 277 330 472 622 519 54 8 229 -3 290 -20z"
      stroke="currentColor"
      strokeWidth="100"
    />
    <path
      d="M4045 4286 c-85 -27 -156 -84 -168 -135 -15 -60 54 -131 112 -116 14 4 46 20 71 37 95 63 192 11 206 -111 9 -79 37 -111 99 -111 67 0 105 50 105 140 0 52 67 110 128 110 16 0 49 -13 74 -30 61 -40 95 -46 134 -21 74 45 62 134 -24 191 -122 81 -277 75 -397 -14 -18 -14 -24 -13 -64 15 -82 55 -189 72 -276 45z"
      stroke="currentColor"
      strokeWidth="100"
    />
    <path
      d="M404 3680 c-60 -24 -73 -112 -25 -161 l29 -29 136 0 c148 0 179 8 202 51 27 52 8 115 -41 137 -30 14 -268 16 -301 2z"
      stroke="currentColor"
      strokeWidth="100"
    />
    <path
      d="M3041 3676 c-47 -27 -63 -84 -37 -135 23 -43 54 -51 202 -51 l136 0 29 29 c38 39 40 97 5 138 l-24 28 -144 3 c-106 1 -149 -1 -167 -12z"
      stroke="currentColor"
      strokeWidth="100"
    />
    <path
      d="M3627 3110 c-62 -24 -113 -63 -133 -102 -13 -26 -14 -38 -5 -69 22 -75 93 -91 171 -39 52 34 106 39 150 14 38 -23 56 -59 63 -124 5 -44 12 -60 37 -82 69 -63 151 -21 163 85 8 66 28 102 68 123 47 24 101 18 147 -16 54 -39 108 -41 145 -5 69 69 18 166 -113 216 -98 37 -232 18 -314 -44 l-33 -25 -29 24 c-76 62 -220 82 -317 44z"
      stroke="currentColor"
      strokeWidth="100"
    />
    <path
      d="M879 2733 c-104 -101 -127 -141 -110 -185 14 -38 58 -68 99 -68 30 0 47 12 130 93 100 97 124 134 115 180 -8 39 -57 77 -100 77 -32 0 -47 -11 -134 -97z"
      stroke="currentColor"
      strokeWidth="100"
    />
    <path
      d="M2672 2805 c-35 -29 -45 -69 -27 -110 7 -16 55 -72 107 -122 83 -81 100 -93 130 -93 41 0 85 30 99 68 17 44 -6 84 -110 185 -87 86 -102 97 -134 97 -23 0 -46 -9 -65 -25z"
      stroke="currentColor"
      strokeWidth="100"
    />
    <path
      d="M1806 2444 c-26 -26 -26 -28 -26 -176 l0 -150 29 -29 c55 -54 139 -29 161 49 11 41 13 186 4 244 -14 84 -110 119 -168 62z"
      stroke="currentColor"
      strokeWidth="100"
    />
    <path
      d="M64 2021 c-12 -5 -31 -22 -43 -37 l-21 -27 0 -939 c0 -1020 -2 -980 55 -1006 20 -9 279 -12 1055 -12 l1030 0 32 29 c27 24 33 36 33 71 0 35 -6 47 -33 71 l-32 29 -970 0 -970 0 0 276 c0 217 3 275 13 271 144 -64 218 -77 319 -57 86 16 158 53 220 109 l51 47 44 -41 c171 -164 450 -164 616 0 l42 42 53 -48 c170 -156 427 -155 605 2 l47 41 48 -44 c172 -154 432 -154 604 0 l48 44 44 -39 c179 -158 439 -161 605 -7 l57 52 43 -43 c165 -164 447 -164 616 1 l42 40 49 -45 c61 -56 139 -95 222 -111 101 -20 175 -7 320 57 9 4 12 -54 12 -271 l0 -276 -970 0 -970 0 -32 -29 c-27 -24 -33 -36 -33 -71 0 -35 6 -47 33 -71 l32 -29 1030 0 c776 0 1035 3 1055 12 57 26 55 -14 55 1007 l0 941 -29 32 c-24 27 -36 33 -70 33 -60 0 -92 -36 -102 -114 -15 -105 -61 -170 -149 -210 -58 -26 -150 -27 -205 -2 -78 35 -145 136 -145 218 0 39 -38 94 -73 106 -68 22 -121 -23 -131 -112 -9 -80 -56 -156 -120 -196 -44 -27 -58 -30 -131 -30 -73 0 -87 3 -131 30 -63 40 -100 100 -118 195 -11 53 -21 80 -37 92 -74 61 -169 3 -169 -104 -1 -45 -30 -107 -71 -147 -131 -131 -362 -73 -414 103 -8 27 -15 62 -15 78 0 16 -12 41 -29 60 -24 27 -36 33 -70 33 -59 0 -90 -34 -101 -112 -20 -143 -117 -233 -251 -233 -66 0 -111 16 -157 56 -53 45 -81 100 -92 177 -6 39 -16 68 -31 83 -60 64 -169 19 -169 -70 0 -12 -7 -45 -15 -72 -31 -105 -126 -174 -240 -174 -137 1 -230 92 -250 244 -11 85 -77 126 -144 90 -37 -20 -44 -34 -62 -126 -15 -82 -60 -145 -129 -181 -48 -25 -63 -28 -126 -25 -129 6 -215 83 -237 214 -15 85 -28 108 -67 124 -63 26 -140 -30 -140 -103 0 -83 -62 -177 -143 -216 -82 -40 -197 -24 -267 37 -51 43 -78 95 -89 173 -6 43 -15 67 -32 84 -27 28 -74 39 -105 26z m771 -411 c77 -80 200 -130 319 -130 120 0 223 40 311 121 l42 39 24 -26 c74 -79 206 -134 322 -134 122 0 225 39 309 117 l48 46 43 -42 c23 -23 76 -59 116 -79 73 -36 77 -37 191 -37 114 0 118 1 191 37 40 20 93 56 116 79 l42 41 53 -47 c90 -81 180 -115 305 -115 117 0 247 54 322 134 l24 26 42 -39 c177 -163 443 -163 620 0 l42 39 44 -41 c24 -23 78 -58 119 -78 73 -35 78 -36 190 -36 109 0 119 2 183 32 l67 32 0 -228 c0 -265 -6 -296 -76 -365 -55 -55 -125 -81 -199 -73 -125 13 -207 97 -225 231 -11 75 -48 116 -106 116 -46 0 -94 -45 -94 -87 0 -55 -31 -134 -67 -174 -56 -62 -105 -83 -188 -83 -82 0 -134 22 -185 80 -40 46 -56 83 -65 153 -6 41 -15 62 -35 83 -58 58 -152 21 -165 -65 -17 -120 -58 -187 -139 -230 -57 -30 -165 -30 -221 0 -84 44 -130 113 -144 215 -9 71 -41 108 -92 108 -70 0 -102 -38 -113 -134 -11 -92 -74 -169 -165 -201 -147 -52 -309 48 -327 201 -11 96 -43 134 -113 134 -51 0 -83 -37 -92 -108 -21 -149 -114 -236 -254 -236 -142 0 -230 86 -250 246 -5 36 -13 53 -36 73 -69 58 -150 16 -164 -86 -9 -70 -25 -107 -65 -153 -51 -58 -103 -80 -185 -80 -80 0 -129 20 -181 76 -44 46 -63 87 -70 155 -13 106 -94 148 -164 86 -25 -23 -33 -39 -40 -91 -31 -219 -272 -308 -424 -156 -70 69 -76 100 -76 365 l0 228 68 -32 c63 -30 73 -32 183 -32 113 0 117 1 190 37 40 20 92 54 114 76 22 21 43 40 46 41 3 0 18 -13 34 -29z"
      stroke="currentColor"
      strokeWidth="150"
    />
    <path
      d="M2498 171 c-27 -24 -33 -36 -33 -71 0 -100 135 -136 181 -49 28 55 11 110 -43 138 -36 18 -71 13 -105 -18z"
      stroke="currentColor"
      strokeWidth="150"
    />
  </ComplexIcon>
);

export const Veranda = () => (
  <ComplexIcon>
    <path
      d="M311 4983 c-17 -14 -53 -132 -166 -535 -80 -284 -145 -526 -145 -538 0 -11 11 -32 25 -45 23 -24 29 -25 160 -25 l135 0 0 -1300 0 -1300 -135 0 c-131 0 -137 -1 -160 -25 -25 -24 -25 -26 -25 -215 0 -189 0 -191 25 -215 13 -14 31 -25 40 -25 13 0 15 -36 15 -295 l0 -296 25 -24 c20 -21 34 -25 82 -25 l58 0 -3 320 -3 320 60 0 61 0 0 58 c0 31 3 67 6 80 6 22 5 22 -100 22 l-106 0 0 80 0 80 140 0 140 0 0 94 c0 78 3 97 20 119 20 25 20 40 20 1286 l0 1261 2080 0 2080 0 0 -142 0 -143 80 0 80 0 0 143 0 142 135 0 c131 0 137 1 160 25 14 13 25 34 25 45 0 12 -65 254 -145 538 -112 401 -150 521 -166 535 -20 16 -142 17 -2249 17 -2107 0 -2229 -1 -2249 -17z m4393 -160 c13 -46 215 -771 221 -795 l7 -28 -2372 0 -2372 0 7 28 c6 24 208 749 221 795 5 16 116 17 2144 17 2028 0 2139 -1 2144 -17z"
      stroke="currentColor"
      strokeWidth="100"
    />
    <path
      d="M2226 3384 c-70 -22 -149 -103 -170 -174 -9 -30 -16 -70 -16 -90 0 -100 62 -200 151 -246 49 -24 49 -25 49 -74 l0 -50 -79 0 c-74 0 -81 -2 -100 -26 -27 -35 -26 -67 3 -101 21 -25 31 -28 100 -31 l76 -4 0 -519 0 -519 -71 0 c-65 0 -73 -2 -100 -29 -36 -36 -37 -73 -4 -106 21 -22 33 -25 100 -25 l75 0 0 -75 0 -75 -60 0 -60 0 0 -80 0 -80 1420 0 1420 0 0 -80 0 -80 -1386 0 -1386 0 6 -22 c3 -13 6 -49 6 -80 l0 -58 1140 0 1140 0 0 -295 0 -296 25 -24 24 -25 231 0 231 0 24 25 25 24 0 296 c0 259 2 295 15 295 9 0 27 11 40 25 25 24 25 26 25 215 0 189 0 191 -25 215 -23 24 -29 25 -160 25 l-135 0 0 75 0 75 135 0 c131 0 137 1 160 25 32 31 32 66 1 102 -24 28 -25 28 -160 31 l-136 4 0 518 0 518 136 4 c135 3 136 3 160 31 31 36 31 71 -1 102 -23 24 -29 25 -160 25 l-135 0 0 50 c0 48 1 50 43 71 124 62 182 198 143 334 -32 110 -148 195 -266 195 -150 0 -280 -130 -280 -280 0 -100 62 -200 151 -246 49 -24 49 -25 49 -74 l0 -50 -1120 0 -1120 0 0 50 c0 48 1 50 43 71 124 62 182 198 143 334 -14 45 -29 69 -70 110 -80 80 -178 103 -290 69z m178 -183 c26 -27 31 -39 31 -81 0 -43 -5 -54 -33 -82 -28 -28 -39 -33 -82 -33 -43 0 -54 5 -82 33 -28 28 -33 39 -33 81 0 52 25 92 70 112 37 16 96 3 129 -30z m2400 0 c26 -27 31 -39 31 -81 0 -43 -5 -54 -33 -82 -28 -28 -39 -33 -82 -33 -43 0 -54 5 -82 33 -28 28 -33 39 -33 81 0 52 25 92 70 112 37 16 96 3 129 -30z m-2164 -1131 l0 -520 -120 0 -120 0 0 520 0 520 120 0 120 0 0 -520z m400 0 l0 -520 -120 0 -120 0 0 520 0 520 120 0 120 0 0 -520z m400 0 l0 -520 -120 0 -120 0 0 520 0 520 120 0 120 0 0 -520z m400 0 l0 -520 -120 0 -120 0 0 520 0 520 120 0 120 0 0 -520z m400 0 l0 -520 -120 0 -120 0 0 520 0 520 120 0 120 0 0 -520z m400 0 l0 -520 -120 0 -120 0 0 520 0 520 120 0 120 0 0 -520z m0 -755 l0 -75 -1120 0 -1120 0 0 75 0 75 1120 0 1120 0 0 -75z m240 -795 l0 -240 -120 0 -120 0 0 240 0 240 120 0 120 0 0 -240z"
      stroke="currentColor"
      strokeWidth="50"
    />
    <path
      d="M705 2735 l-25 -24 0 -736 c0 -656 -2 -735 -15 -735 -9 0 -27 -11 -40 -25 -24 -23 -25 -29 -25 -160 0 -115 -2 -135 -15 -135 -9 0 -27 -11 -40 -25 -24 -23 -25 -29 -25 -160 l0 -135 -35 0 c-25 0 -44 -8 -60 -25 -25 -24 -25 -26 -25 -215 0 -189 0 -191 25 -215 l24 -25 831 0 831 0 24 25 c25 24 25 26 25 215 0 -189 0 -191 -25 -215 -16 17 -35 25 -60 25 l-35 0 0 135 c0 131 -1 137 -25 160 -13 14 -31 25 -40 25 -13 0 -15 20 -15 135 0 131 -1 137 -25 160 -13 14 -31 25 -40 25 -13 0 -15 79 -15 735 l0 736 -25 24 -24 25 -551 0 -551 0 -24 -25z m1015 -815 l0 -680 -440 0 -440 0 0 680 0 680 440 0 440 0 0 -680z m80 -920 l0 -80 -520 0 -520 0 0 80 0 80 520 0 520 0 0 -80z m80 -320 l0 -80 -600 0 -600 0 0 80 0 80 600 0 600 0 0 -80z m120 -320 l0 -80 -720 0 -720 0 0 80 0 80 720 0 720 0 0 -80z"
      stroke="currentColor"
      strokeWidth="50"
    />
  </ComplexIcon>
);

export const Wifi = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.0"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 20h.01" />
    <path d="M2 8.82a15 15 0 0 1 20 0" />
    <path d="M5 12.85a10 10 0 0 1 14 0" />
    <path d="M8.5 16.48a5 5 0 0 1 7 0" />
  </svg>
);

export const House = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);

export const TV = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    style={{
      display: "block",
      height: "24px",
      width: "24px",
      fill: "none", // Keine Füllung
      stroke: "currentColor", // Farbe wird übernommen
      strokeWidth: "1.5", // HIER kannst du die Dicke steuern (z.B. 1.2 für noch dünner)
      strokeLinecap: "round",
      strokeLinejoin: "round",
    }}
    {...props}
  >
    <rect x="3" y="4" width="18" height="12" rx="2" />

    <path d="M12 16v4" />
    <path d="M8 20h8" />
  </svg>
);

export const Sofa = (props) => (
  <svg {...IconProps} {...props}>
    <path d="M20 9V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v2" />
    <rect x="2" y="9" width="20" height="8" rx="2" />
    <path d="M4 17v2m16-2v2" />
  </svg>
);

export const Shower = (props) => (
  <svg {...IconProps} {...props}>
    <path d="M4 4h16v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4z" />
    <path d="M12 8v12" />
    <path d="M8 20h8" />
    <path d="M10 12l-2 2m6-2l2 2m-4-2v3" />
  </svg>
);

export const ToiletPaper = (props) => (
  <svg {...IconProps} {...props}>
    <circle cx="12" cy="7" r="5" />
    <path d="M7 7v10l5 3 5-3V7" />
  </svg>
);

export const DryingRack = (props) => (
  <svg {...IconProps} {...props}>
    <path d="M4 5h16M4 10h16M4 15h16" />
    <path d="M6 3v18M18 3v18" />
  </svg>
);

export const BedLinen = (props) => (
  <svg {...IconProps} {...props}>
    <path d="M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" />
    <path d="M3 13h18M7 5v8m10-8v8" />
  </svg>
);

export const Wardrobe = (props) => (
  <svg {...IconProps} {...props}>
    <rect x="4" y="2" width="16" height="20" rx="2" />
    <path d="M12 2v20M9 12h.01M15 12h.01" />
  </svg>
);

export const Table = (props) => (
  <svg {...IconProps} {...props}>
    <path d="M3 7h18m-2 0v12m-14-12v12m2-12v5h10v-5" />
  </svg>
);

export const GasHob = (props) => (
  <svg {...IconProps} {...props}>
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <circle cx="7" cy="9" r="2" />
    <circle cx="17" cy="9" r="2" />
    <circle cx="7" cy="15" r="2" />
    <circle cx="17" cy="15" r="2" />
  </svg>
);

export const ForkKnife = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M18 2v20M2 12h14M2 2v10c0 2 2 4 4 4s4-2 4-4V2M7 2v4M11 2v4M3 2v4" />
  </svg>
);

export const Umbrella = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M12 12v9" />
    <path d="M12 12l4-4" />
    <path d="M12 12l-4-4" />
    <path d="M20 12a8 8 0 0 0-16 0Z" />
    <path d="M3 21h18" />
    <path d="M3 18c2 0 2-1 4-1s2 1 4 1 2-1 4-1 2 1 4 1 2-1 4-1" />
  </svg>
);

export const Plane = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 -960 960 960"
    fill="currentColor"
    style={{ display: "inline-block", verticalAlign: "middle" }}
    {...props}
  >
    <g transform="rotate(45 480 -480)">
      <path d="M333.5-60v-70.5l81-59.5v-225L60-310.5V-399l354.5-207v-228.5q0-28.5 19-47.5t46.5-19q27.5 0 46.5 19t19 47.5V-606L901-399v88.5L545.5-415v224.5l82.5 60V-60l-147.5-40.5-147 40.5Z" />
    </g>
  </svg>
);

export const Activity = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="12" cy="12" r="10" />
    <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
  </svg>
);

export const RainShower = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    style={{
      display: "block",
      height: "24px",
      width: "24px",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
    }}
  >
    <path d="M16 2v6" />

    <rect x="2" y="8" width="28" height="4" rx="2" />

    <path d="M16 15v4" />
    <path d="M16 24v5" />

    <path d="M8 15v3" />
    <path d="M8 23v6" />

    <path d="M24 15v3" />
    <path d="M24 23v6" />
  </svg>
);

export const Toaster = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    style={{
      display: "block",
      height: "24px",
      width: "24px",
      fill: "currentcolor",
    }}
  >
    <path d="M20.93 2a3.93 3.93 0 0 1 3.93 3.93c0 .87-.29 1.7-.83 2.4l-.03.04V10a5 5 0 0 1 5 4.78V27a2 2 0 0 1-1.85 2H26v1h-2v-1H8v1H6v-1H5a2 2 0 0 1-2-1.85V17H1v-2h2a5 5 0 0 1 4.78-5H8V8.38a3.93 3.93 0 0 1 0-4.9l.14-.17.15-.16a3.93 3.93 0 0 1 2.56-1.14l.22-.01h9.86zM24 12H8a3 3 0 0 0-3 2.82V27h22V15a3 3 0 0 0-2.82-3H24zM8 23a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM20.93 4h-9.86a1.93 1.93 0 0 0-1.36 3.3 1 1 0 0 1 .28.57L10 8v2h12V8a1 1 0 0 1 .12-.48l.07-.1.08-.1.12-.13a1.93 1.93 0 0 0-1.31-3.18L20.93 4z"></path>
  </svg>
);

export const Kettle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    style={{
      display: "block",
      height: "24px",
      width: "24px",
      fill: "currentcolor ",
    }}
  >
    <path d="M26 28v2H6v-2h20zM16 1a8.64 8.64 0 0 1 7.83 5H28a1 1 0 0 1 1 1.08c-.3 3.87-1.58 6.45-3.9 7.56l.9 10.27a1 1 0 0 1-.88 1.08L25 26H7a1 1 0 0 1-1-.97v-.12L7.4 8.9c.02-.3.06-.6.12-.89H5a1 1 0 0 0-1 .88V19H2V9a3 3 0 0 1 2.82-3h3.35A8.64 8.64 0 0 1 16 1zm6.43 7H9.57a6.65 6.65 0 0 0-.14.7l-.04.36L8.1 24h15.82L22.6 9.06A6.67 6.67 0 0 0 22.43 8zm-5.45 3a9.82 9.82 0 0 1-2.7 5.78l-.23.24A6.96 6.96 0 0 0 12.07 21h-2.02a8.96 8.96 0 0 1 2.36-5.16l.23-.23A7.99 7.99 0 0 0 14.97 11h2.01zm4 0 .02.5a9.6 9.6 0 0 1-2.72 6.28l-.23.24A6.97 6.97 0 0 0 16.28 21h-2.06a8.96 8.96 0 0 1 2.19-4.16l.22-.23C18.09 15.16 19 13.2 19 11.5a4.94 4.94 0 0 0-.03-.5h2.01zm5.9-3h-2.4l.1.63.02.26.3 3.51c.99-.79 1.64-2.16 1.96-4.17l.03-.23zM16 3a6.63 6.63 0 0 0-5.55 3h11.1a6.63 6.63 0 0 0-5.04-2.98L16.23 3H16z"></path>
  </svg>
);

export const Blender = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    style={{
      display: "block",
      height: "24px",
      width: "24px",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
    }}
    {...props}
  >
    <path d="M9 5h6" />
    <path d="M11 3h2" />

    <path d="M10 5L8 16h8l-2-11" />

    <path d="M16 7h1a3 3 0 0 1 0 6h-1" />

    <path d="M8 16v3a3 3 0 0 0 3 3h2a3 3 0 0 0 3-3v-3" />

    <circle cx="12" cy="19" r="1" />

    <path d="M10 11l2 2 2-2" />
  </svg>
);

export const Dishwasher = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    style={{
      display: "block",
      height: "24px",
      width: "24px",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
    }}
    {...props}
  >
    <rect x="4" y="3" width="16" height="18" rx="2" />

    <path d="M4 7h16" />

    <path d="M9 10h6" />

    <path d="M6 14h12" />

    <path d="M6 17h12" />

    <path d="M8 21v-2" />
    <path d="M16 21v-2" />
    <path d="M12 21v-2" />
  </svg>
);

export const BabyCrib = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    style={{
      display: "block",
      height: "24px",
      width: "24px",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
    }}
    {...props}
  >
    <rect x="4" y="8" width="16" height="8" rx="1" />

    <path d="M4 16v3" />
    <path d="M20 16v3" />

    <path d="M8 8v8" />
    <path d="M12 8v8" />
    <path d="M16 8v8" />

    <path d="M4 8l2-3h12l2 3" />
  </svg>
);

export const HighChair = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    style={{
      display: "block",
      height: "24px",
      width: "24px",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
    }}
    {...props}
  >
    <path d="M7 21l3-10V5a2 2 0 0 1 2-2h1" />

    <path d="M10 11h5a2 2 0 0 1 2 2v1" />

    <path d="M13 14l3 7" />

    <path d="M14 10h5a1 1 0 0 1 1 1v1" />

    <path d="M9 17h5" />
  </svg>
);

export const GasDetector = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    style={{
      display: "block",
      height: "24px",
      width: "24px",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
    }}
    {...props}
  >
    <rect x="4" y="4" width="16" height="16" rx="2" />

    <circle cx="12" cy="14" r="5" />

    <path d="M9 12h6" />
    <path d="M9 14h6" />
    <path d="M9 16h6" />

    <circle cx="8" cy="8" r="1" />
    <circle cx="16" cy="8" r="1" />
  </svg>
);

export const SunLounger = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    style={{
      display: "block",
      height: "24px",
      width: "24px",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
    }}
    {...props}
  >
    <path d="M4 16h10" />

    <path d="M14 16l6-8" />

    <path d="M16 13l-2 3" />

    <path d="M6 16v4" />

    <path d="M18 16v4" />

    <path d="M18 8h2" />
  </svg>
);

export const CampingChair = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    style={{
      display: "block",
      height: "24px",
      width: "24px",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
    }}
    {...props}
  >
    <path d="M6 20L18 8" />
    <path d="M18 20L6 8" />

    <path d="M6 8V3" />
    <path d="M18 8V3" />

    <path d="M6 8c0 3 12 3 12 0" />

    <path d="M6 3h12" />
  </svg>
);

export const PaddleBoard = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    style={{
      display: "block",
      height: "24px",
      width: "24px",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
    }}
    {...props}
  >
    <rect x="5" y="3" width="7" height="18" rx="3.5" />

    <path d="M16 3h4" />

    <path d="M18 3v13" />

    <path d="M18 16c0 2.5-2 5-2 5s-2-2.5-2-5h4z" />
  </svg>
);

// --- Neue Verbots-Icons ---
export const NoSmoking = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    style={{
      display: "block",
      height: "24px",
      width: "24px",
      fill: "none",
      stroke: "#000000",
      strokeWidth: "2.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
    }}
    {...props}
  >
    <g
      transform="translate(2, 30) scale(0.0022, -0.0022)"
      fill="#000000"
      stroke="none"
    >
      <path d="M7665 10856 c-462 -122 -806 -515 -912 -1041 -27 -136 -24 -425 5 -562 105 -487 423 -881 927 -1148 104 -55 115 -66 115 -114 0 -41 25 -183 47 -261 80 -293 247 -492 500 -595 107 -43 240 -72 507 -110 142 -20 302 -47 355 -61 257 -64 411 -203 490 -440 37 -112 60 -246 67 -394 7 -157 11 -179 41 -206 28 -26 79 -32 114 -14 43 23 52 65 46 201 -18 366 -101 622 -258 792 -167 181 -352 255 -779 312 -223 29 -325 48 -425 77 -310 89 -476 333 -510 749 -11 132 -16 139 -169 216 -483 246 -778 595 -872 1033 -22 103 -29 306 -15 412 64 480 374 861 785 962 131 33 169 70 146 141 -24 73 -74 86 -205 51z" />
      <path d="M8935 10195 c-19 -18 -25 -35 -25 -68 0 -43 3 -46 94 -131 118 -108 183 -193 246 -321 152 -313 142 -664 -32 -1059 -44 -100 -137 -267 -204 -365 -74 -108 -60 -157 62 -219 92 -46 186 -77 359 -116 192 -45 267 -67 340 -101 315 -149 467 -619 505 -1560 6 -143 13 -271 16 -283 19 -89 155 -95 183 -9 19 57 -8 596 -45 882 -65 506 -174 804 -369 1000 -134 135 -247 188 -545 255 -175 39 -277 70 -291 86 -8 10 -1 30 32 81 108 172 224 456 263 643 73 356 13 709 -165 981 -63 96 -194 239 -270 295 -59 43 -117 47 -154 9z" />

      <path d="M8870 5115 c525 -525 578 -575 608 -575 l32 0 -2 573 -3 572 -605 3 -605 2 575 -575z" />
      <path d="M9770 5115 l0 -575 115 0 115 0 -2 573 -3 572 -112 3 -113 3 0 -576z" />
      <path d="M10260 5115 l0 -575 75 0 c82 0 149 21 165 51 6 11 10 217 10 527 l0 509 -22 20 c-30 28 -89 43 -165 43 l-63 0 0 -575z" />
      <path d="M2110 5678 c-19 -5 -45 -19 -57 -31 l-23 -20 0 -509 c0 -310 4 -516 10 -527 5 -10 28 -26 50 -35 37 -15 258 -16 2525 -16 1367 0 2485 3 2485 8 0 4 -255 263 -568 575 l-567 567 -1910 -1 c-1229 0 -1922 -4 -1945 -11z" />
    </g>

    <circle cx="16" cy="16" r="13" />

    <line x1="7" y1="7" x2="25" y2="25" />
  </svg>
);

export const NoSmoking2 = (props) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    // viewBox leicht verkleinert (von 1280 auf 1100) für den "Zoom"
    viewBox="0 0 1570 1570"
    preserveAspectRatio="xMidYMid meet"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    style={{
      display: "block",
    }}
    {...props}
  >
    <g
      transform="translate(150.000000,1400.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path d="M6270 12783 c-675 -13 -1400 -148 -2033 -378 -483 -176 -974 -425 -1387 -701 -1223 -821 -2124 -2031 -2554 -3431 -165 -537 -245 -1002 -280 -1638 -14 -251 -12 -332 14 -705 139 -1964 1190 -3761 2840 -4855 907 -602 1963 -965 3035 -1045 83 -6 200 -15 261 -20 140 -13 345 -13 471 -1 54 6 168 15 253 21 1957 142 3764 1208 4853 2865 578 879 932 1903 1021 2945 47 550 46 681 -9 1225 -190 1874 -1225 3591 -2801 4642 -392 262 -824 486 -1259 653 -766 294 -1596 439 -2425 423z m365 -1073 c779 -38 1467 -218 2155 -561 1489 -744 2545 -2152 2845 -3794 104 -568 112 -1192 24 -1765 -111 -716 -367 -1403 -755 -2023 -120 -191 -343 -499 -370 -511 -6 -2 -1691 1676 -3744 3729 -3734 3734 -3734 3734 -3715 3755 28 31 221 175 360 268 363 245 786 457 1213 608 460 164 995 268 1498 293 237 12 261 12 489 1z m-608 -5682 c2053 -2053 3733 -3738 3733 -3744 0 -6 -37 -40 -82 -75 -1291 -1009 -2968 -1367 -4558 -973 -2370 587 -4040 2720 -4040 5160 0 1190 405 2350 1153 3302 27 34 52 62 55 62 4 0 1687 -1680 3739 -3732z" />
      <path d="M7665 10856 c-462 -122 -806 -515 -912 -1041 -27 -136 -24 -425 5 -562 105 -487 423 -881 927 -1148 104 -55 115 -66 115 -114 0 -41 25 -183 47 -261 80 -293 247 -492 500 -595 107 -43 240 -72 507 -110 142 -20 302 -47 355 -61 257 -64 411 -203 490 -440 37 -112 60 -246 67 -394 7 -157 11 -179 41 -206 28 -26 79 -32 114 -14 43 23 52 65 46 201 -18 366 -101 622 -258 792 -167 181 -352 255 -779 312 -223 29 -325 48 -425 77 -310 89 -476 333 -510 749 -11 132 -16 139 -169 216 -483 246 -778 595 -872 1033 -22 103 -29 306 -15 412 64 480 374 861 785 962 131 33 169 70 146 141 -24 73 -74 86 -205 51z" />
      <path d="M8935 10195 c-19 -18 -25 -35 -25 -68 0 -43 3 -46 94 -131 118 -108 183 -193 246 -321 152 -313 142 -664 -32 -1059 -44 -100 -137 -267 -204 -365 -74 -108 -60 -157 62 -219 92 -46 186 -77 359 -116 192 -45 267 -67 340 -101 315 -149 467 -619 505 -1560 6 -143 13 -271 16 -283 19 -89 155 -95 183 -9 19 57 -8 596 -45 882 -65 506 -174 804 -369 1000 -134 135 -247 188 -545 255 -175 39 -277 70 -291 86 -8 10 -1 30 32 81 108 172 224 456 263 643 73 356 13 709 -165 981 -63 96 -194 239 -270 295 -59 43 -117 47 -154 9z" />
      <path d="M8870 5115 c525 -525 578 -575 608 -575 l32 0 -2 573 -3 572 -605 3 -605 2 575 -575z" />
      <path d="M9770 5115 l0 -575 115 0 115 0 -2 573 -3 572 -112 3 -113 3 0 -576z" />
      <path d="M10260 5115 l0 -575 75 0 c82 0 149 21 165 51 6 11 10 217 10 527 l0 509 -22 20 c-30 28 -89 43 -165 43 l-63 0 0 -575z" />
      <path d="M2110 5678 c-19 -5 -45 -19 -57 -31 l-23 -20 0 -509 c0 -310 4 -516 10 -527 5 -10 28 -26 50 -35 37 -15 258 -16 2525 -16 1367 0 2485 3 2485 8 0 4 -255 263 -568 575 l-567 567 -1910 -1 c-1229 0 -1922 -4 -1945 -11z" />
    </g>
  </svg>
);

export const NoPets = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    style={{
      display: "block",
      height: "24px",
      width: "24px",
      fill: "none",
      stroke: "#000000", // Farbe von NoSmoking übernommen
      strokeWidth: "2.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
    }}
    {...props}
  >
    <circle cx="16" cy="16" r="13" />
    <line x1="7" y1="7" x2="25" y2="25" />
    <g transform="translate(5.5, 5.5) scale(0.85)">
      <path
        fill="#000000" // Auch die Füllung der Pfote angepasst
        stroke="none"
        d="M16.01 15a4.5 4.5 0 1 0-9 0l.75-.75a3.75 3.75 0 1 0 0 7.5 4.96 4.96 0 0 0 2.245-.59 3.28 3.28 0 0 1 3.018.005c.677.365 1.44.567 2.22.585a3.75 3.75 0 1 0 .018-7.5zm-1.5 0c0 .414.336.75.75.75a2.25 2.25 0 0 1 0 4.5 3.4 3.4 0 0 1-1.536-.41 4.79 4.79 0 0 0-4.42-.005 3.46 3.46 0 0 1-1.562.415A2.247 2.247 0 0 1 5.51 18a2.25 2.25 0 0 1 2.25-2.25.75.75 0 0 0 .75-.75 3 3 0 1 1 6 0m-9.75-3.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m1.5 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0m3-6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m1.5 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0m6 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m1.5 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0m3.75 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m1.5 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0"
      />
    </g>
  </svg>
);

export const NoParty = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    aria-hidden="true"
    role="presentation"
    focusable="false"
    style={{
      display: "block",
      height: "24px",
      width: "24px",
      fill: "none",
      stroke: "#000000", // Farbe von NoSmoking übernommen
      strokeWidth: "2.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
    }}
    {...props}
  >
    <circle cx="16" cy="16" r="13" />
    <line x1="7" y1="7" x2="25" y2="25" />
    <g transform="translate(4, 4)">
      <path d="M19 18 12 4 5 18c0 1 3.13 2 7 2s7-1 7-2Z" />
      <circle cx="12" cy="3" r="1" />
      <path d="M7.5 13.5c1.5 1 6.5 1 9 0" />
      <path d="M9.5 8.5c1.5.7 3.5.7 5 0" />
      <path d="M3 10l1-1" />
      <path d="M20 7l-1 1" />
    </g>
  </svg>
);
